<template>
  <div
    v-if="order && order?.id && !cameBackFromCheckout"
    class="app-step-one-form-resume-order"
  >
    <h3 class="app-step-one-form-resume-order__header">
      Your Last Order In Progress - Resume It Below
    </h3>
    <div class="app-step-one-form-resume-order__body">
      <div class="app-step-one-form-resume-order__wrapper">
        <div class="app-step-one-form-resume-order__date">
          <p>Date</p>
          <p>
            {{ lastOrderDate }}
          </p>
        </div>
        <div v-if="packageName" class="app-step-one-form-resume-order__package">
          <p>Package</p>
          <p>{{ packageName }}</p>
        </div>
      </div>

      <button
        @click="handleResume"
        class="app-step-one-form-resume-order__btn"
      >
        <span>Resume Your Most Recent Order</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useOrder } from '@core/composables/order/useOrder.js'
import { OrderTypes } from '@modules/app-steps/step-two/tabs/tabs-data'
import { BILLING_PAGE_TAB_VALUE } from '@/stores/tabs'

import moment from 'moment'

const router = useRouter()
const { getLastIncompleteOrder } = useOrder()

const { order, packageName } = getLastIncompleteOrder()

function isInProgressOrderPath(location) {
  if (!location || typeof location !== 'string') return false

  const pathname = location.split(/[?#]/)[0]
  return /^\/order\/\d+(?:\/(?:billing|misc-sale))?\/?$/.test(pathname)
}

const cameBackFromCheckout = isInProgressOrderPath(
  router.options.history.state?.forward
)

const handleResume = () => {
  const incompleteOrder = order.value
  if (!incompleteOrder?.id) return

  if (incompleteOrder.orderType === OrderTypes.MiscSale) {
    const atBilling =
      Number(incompleteOrder.metadata?.currentTab) === BILLING_PAGE_TAB_VALUE ||
      Number(incompleteOrder.total) > 0

    router.push({
      name: atBilling ? 'order-billing' : 'order-misc-sale',
      params: { id: incompleteOrder.id },
    })
    return
  }

  router.push({ name: 'single-order', params: { id: incompleteOrder.id } })
}

function getTimeDifferenceText(dateString) {
  const now = moment()
  const pastDate = moment(dateString)

  const weeksDifference = now.diff(pastDate, 'weeks')
  const daysDifference = now.diff(pastDate, 'days')

  if (daysDifference === 0) {
    return 'Today'
  } else if (daysDifference === 1) {
    return `${daysDifference} day ago`
  } else if (daysDifference < 7) {
    return `${daysDifference} days ago`
  } else if (weeksDifference >= 1 && weeksDifference < 52) {
    return `${weeksDifference} ${weeksDifference === 1 ? 'week' : 'weeks'} ago`
  }
}
const lastOrderDate = computed(() => {
  if (order?.value) {
    return getTimeDifferenceText(order?.value?.timestamp)
  } else {
    return ''
  }
})
</script>
